import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-10c19968"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "holder"
};
const _hoisted_3 = {
  class: "breadcrumbs",
  itemscope: "",
  itemtype: "http://schema.org/BreadcrumbList"
};
const _hoisted_4 = {
  itemprop: "itemListElement",
  itemscope: "",
  itemtype: "http://schema.org/ListItem"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  itemprop: "name"
}, "Коллекция", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  itemprop: "position",
  content: "1"
}, null, -1));

const _hoisted_7 = {
  itemprop: "itemListElement",
  itemscope: "",
  itemtype: "http://schema.org/ListItem"
};
const _hoisted_8 = {
  itemprop: "item"
};
const _hoisted_9 = {
  itemprop: "name"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  itemprop: "position",
  content: "2"
}, null, -1));

const _hoisted_11 = {
  class: "title work-name"
};
const _hoisted_12 = {
  class: "work-about",
  style: {
    "padding": "0"
  }
};
const _hoisted_13 = {
  class: "col-left"
};
const _hoisted_14 = {
  class: "work-img"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "work-content"
};
const _hoisted_17 = {
  class: "work-author"
};
const _hoisted_18 = {
  class: "work-author-top"
};
const _hoisted_19 = {
  class: "work-author-about"
};
const _hoisted_20 = {
  class: "work-author-name"
};
const _hoisted_21 = {
  class: "work-info"
};

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "show-more-hidden"
}, null, -1));

const _hoisted_23 = {
  class: "stats"
};
const _hoisted_24 = {
  key: 0,
  class: "stats-item"
};

const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "stats-name"
}, " Материал: ", -1));

const _hoisted_26 = {
  class: "stats-val"
};
const _hoisted_27 = {
  key: 1,
  class: "stats-item"
};

const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "stats-name"
}, " Размер: ", -1));

const _hoisted_29 = {
  class: "stats-val"
};
const _hoisted_30 = {
  key: 2,
  class: "stats-item"
};

const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "stats-name"
}, " Цена: ", -1));

const _hoisted_32 = {
  class: "stats-val"
};
const _hoisted_33 = {
  class: "author-works"
};
const _hoisted_34 = {
  class: "title-line"
};

const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, " Другие работы ", -1));

const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Смотреть всю коллекцию ");

const _hoisted_37 = {
  class: "catalog"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  const _component_el_image = _resolveComponent("el-image");

  const _component_work_card_component = _resolveComponent("work-card-component");

  const _directive_img = _resolveDirective("img");

  return _openBlock(), _createElementBlock("section", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("ol", _hoisted_3, [_createElementVNode("li", _hoisted_4, [_createVNode(_component_router_link, {
    itemprop: "item",
    style: {
      "cursor": "pointer"
    },
    to: {
      name: 'works'
    }
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  }), _hoisted_6]), _createElementVNode("li", _hoisted_7, [_createElementVNode("span", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString($data.Work.name), 1)]), _hoisted_10])]), _createElementVNode("h2", _hoisted_11, _toDisplayString($data.Work.name), 1), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
    src: $data.Work.thumbWithPath,
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.openImageViewer && $options.openImageViewer(...args))
  }, null, 8, _hoisted_15)])]), $data.Work.status_id !== 3 ? (_openBlock(), _createBlock(_component_el_image, {
    key: 0,
    ref: "triggerPreview",
    style: {
      "display": "none"
    },
    src: $data.Work.thumbWithPath,
    "preview-teleported": true,
    "preview-src-list": $options.previewList,
    "initial-index": 0
  }, null, 8, ["src", "preview-src-list"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, " Автор: " + _toDisplayString($data.Work.author), 1)])])]), _createElementVNode("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.description, (item, index) => {
    return _openBlock(), _createElementBlock("p", {
      key: index
    }, _toDisplayString(item), 1);
  }), 128)), _hoisted_22, $data.moreBlock ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    href: "",
    class: "show-more",
    onClick: _cache[1] || (_cache[1] = $event => $data.fullDesc = !$data.fullDesc)
  }, "Читать больше")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_23, [$data.Work.material ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, _toDisplayString($data.Work.material), 1)])) : _createCommentVNode("", true), $data.Work.size ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_hoisted_28, _createElementVNode("div", _hoisted_29, _toDisplayString($data.Work.size), 1)])) : _createCommentVNode("", true), $data.Work.price ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", _hoisted_32, _toDisplayString($data.Work.price), 1)])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_hoisted_35, _createVNode(_component_router_link, {
    style: {
      "cursor": "pointer"
    },
    to: {
      name: 'works'
    },
    class: "title-link"
  }, {
    default: _withCtx(() => [_hoisted_36]),
    _: 1
  })]), _createElementVNode("div", _hoisted_37, [_createVNode(_component_work_card_component, {
    works: $data.Works
  }, null, 8, ["works"])])])])), [[_directive_img, {
    classes: ['.work-about .work-img img']
  }]])]);
}